import React, {
  FC,
  Suspense,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { connect, useDispatch, useSelector } from 'react-redux';
import IdleTimerContainer from './components/IdleTimer';
import notify from '../lib/notifiy';
import ErrorScreen from '../components/ErrorScreen';
import Loader from '../components/Loader';
import OpenRoute from '../routes/OpenRoute';
import routesConfig, { EdgeV3Payments } from '../routes/routesConfig';
import PrivateRoute from '../routes/PrivateRoute';
import AdminLoginPrivateRoute from '../routes/AdminLoginPrivateRoute';
import PayoutPrivateRoute from '../routes/PayoutPrivateRoute';
import PaymentLinksPrivateRoute from '../routes/PaymentLinksPrivateRoute';
import EdgePaymentLinksPrivateRoute from '../routes/EdgePaymentLinksPrivateRoute';
import ProfileRoute from '../routes/ProfileRoute';
import {
  checkPermissions,
  convertSecondsToMilliSeconds,
  getDashboardThemeDetails,
  getIsAdapterFromStore,
  getIsAdminFromStore,
  getSelectedProductFromPath,
} from '../lib/helper';
import { getMerchantOdsDataAction } from '../redux/actions/merchantListing';
import {
  refreshTokenAction,
  clearLoginAction,
  logOutAction,
  clearLogOutAction,
  getClientSecretKeyAction,
  updateSelectedProductOnPathChange,
  setUserDataAction,
} from '../redux/actions/login';
import {
  validationErrorAction,
  clearValidationErrorAction,
} from '../redux/actions/validationErrors';
import { getDisputesFeatureFlagAction } from '../redux/actions/disputes';
import useRedirect from '../hooks/useRedirect';
import useOnlineHook from '../hooks/useOnlineHook';
import {
  REFRESH_TOKEN_MARGINAL_TIME,
  UiRoutes,
  DISPUTES_FEATURE_API_ENABLED,
} from '../lib/constants';
import {
  removeUserAuthenticated,
  setUserAuthenticated,
  removeIsLiveMerchant,
} from '../lib/localStorage';
import Props from './typing';
import { permissionEnum } from '../lib/typing';
import 'antd/dist/antd.css';
import '../scss/common.scss';
import '../components/CustomSwitch/styles.scss';
import imgURL from '../lib/imgURL';
import { routeConfigType } from '../lib/typing';
import CommonLayout from '../routes/CommonRoute';
import EdgePrivateRoute from '../routes/EdgePrivateRoute';
import {
  getRefreshTokenPayloadForPath,
  getRootRedirectPath,
  shouldDeferRootRedirect,
} from './authRoutes';

// import { config } from 'process';
// import socketIOClient from 'socket.io-client';
// import urlconfig from '../config';
// const ENDPOINT = `${urlconfig().API.API_BASE_URL}/plural-websocket`;
import { ProfileMessageMapping, statusMapper } from './constants';
import {
  updateMerchantProfileAction,
  updateMerchantProfileStore,
} from '../redux/actions/completeProfile';
import {
  pushClevertapProfile,
  pushProfileProperties,
  isCitiTheme,
  pushLast9Profile,
} from '../lib/analyticsUtil';
import {
  installNetworkErrorBodyCapture,
  getErrorResponseBody,
  extractUpstreamMessage,
} from '../lib/networkErrorCache';
import PartnerMerchantPrivateRoute from '../routes/PartnerMerchantPrivateRoute';
import CompleteProfileRoute from '../routes/CompleteProfileRoute';
import SubscriptionPrivateRoute from '../routes/SubscriptionPrivateRoute';
import PublicCompleteProfileRoute from '../routes/PublicCompleteProfileRoute';
import generateColorPalette from '../utils/color';
import { isPublicSelfServePath } from '../routes/publicSelfServeRoutes';

const App: FC<Props> = (props): JSX.Element => {
  const { push, location } = useRedirect();
  const { pathname: pathName } = location;
  const isPublicSelfServeRoute = isPublicSelfServePath(pathName);
  const isOnline = useOnlineHook();
  const { isAdmin } = props.loginState;
  const isCiti = isCitiTheme();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [kycdata, setKycdata] = useState<any>({});
  const [color, setColor] = useState<string>('');

  useEffect(() => {
    const gtmId = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID;

    if (!gtmId) {
      return;
    }

    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event: 'pageview',
      page: window.location.pathname,
    });
  }, [pathName]);

  useEffect(() => {
    if (props?.themingDetails?.brandColor) {
      setColor(props?.themingDetails?.brandColor);
    }
  }, [props?.themingDetails?.brandColor]);

  useEffect(() => {
    if (props?.loginState?.isUserAuthenticated) {
      props.getMerchantOdsDataAction();
    }
  }, [props?.loginState?.isUserAuthenticated, props?.loginState?.MerchantId]);

  const changeTheme = (obj: any): void => {
    const root = document.documentElement;
    root.style.setProperty(
      '--primary-color-1',
      obj['--primary-color-1']
    );
    root.style.setProperty(
      '--primary-color-2',
      obj['--primary-color-2']
    );
    root.style.setProperty(
      '--primary-color-3',
      obj['--primary-color-3']
    );
    root.style.setProperty(
      '--primary-color-4',
      obj['--primary-color-4']
    );
    root.style.setProperty(
      '--primary-color-5',
      obj['--primary-color-5']
    );
    root.style.setProperty(
      '--primary-color-6',
      obj['--primary-color-6']
    );
    root.style.setProperty(
      '--primary-color-7',
      obj['--primary-color-7']
    );
    root.style.setProperty(
      '--color-primary-light',
      obj['--color-primary-light']
    );
    root.style.setProperty(
      '--color-primary-medium',
      obj['--color-primary-medium']
    );
    root.style.setProperty(
      '--sidebar-active',
      obj['--sidebar-active']
    );
    root.style.setProperty(
      '--sidebar-hover',
      obj['--sidebar-hover']
    );
    root.style.setProperty(
      '--color-primary-dark',
      obj['--color-primary-dark']
    );
    root.style.setProperty('--secondary-color-1',
       obj['--secondary-color-1']
      );
      root.style.setProperty('--secondary-color-2',
       obj['--secondary-color-2']
      );

  };

  useEffect(() => {
    if (color) {
      const palettes = generateColorPalette(color).palette;
      changeTheme({
        '--primary-color-1': palettes['900'],
        '--primary-color-2': palettes['900'],
        '--primary-color-3': palettes['900'],
        '--primary-color-4': palettes['900'],
        '--primary-color-5': palettes['900'],
        '--primary-color-6': palettes['900'],
        '--primary-color-7': palettes['900'],
        '--secondary-color-1': palettes['900'],
        '--color-primary-medium': palettes['300'],
        '--color-primary-light': palettes['200'],
        '--sidebar-active': palettes['100'],
        '--sidebar-hover': palettes['100'],
        '--highlighted-text-color': palettes['700'],
        '--color-primary-dark': palettes['600'],
      });
    } else if (isCiti) {
      changeTheme({
        '--primary-color-1': '#255BE3',
        '--primary-color-2': '#255BE3',
        '--primary-color-3': '#255BE3',
        '--primary-color-4': '#255BE3',
        '--primary-color-5': '#255BE3',
        '--primary-color-6': '#255BE3',
        '--primary-color-7': '#255BE3',
        '--secondary-color-1': '#255BE3',
        '--color-primary-medium': '#255BE310',
        '--color-primary-light': '#255BE308',
        '--sidebar-active': ' #255BE31A',
        '--sidebar-hover': '#255BE30A',
        '--color-primary-dark': '#220037'
      });
    }else{
      changeTheme(
        {
          '--primary-color-1': '#003323',
          '--primary-color-2': '#003323',
          '--primary-color-3': '#003323',
          '--primary-color-4': '#003323',
          '--primary-color-5': '#003323',
          '--primary-color-6': '#003323',
          '--primary-color-7': '#003323',
          '--secondary-color-1': '#006646',
          '--secondary-color-2': '#99CCBA',
          '--color-primary-medium': '#00332310',
          '--color-primary-light': '#00332308',
          '--sidebar-active': '#F1F2F4',
          '--sidebar-hover': '#00332314',
          '--color-primary-dark': '#006646'
        });
    }
  },[isCiti, color]);

  // listner for multi-tab logout
  window.addEventListener('storage', (e) => {
    if (e.key === 'user' && e.oldValue && !e.newValue) {
      props.clearLogOutAction();
      props.clearLoginAction();
      isAdmin ? push(UiRoutes.ADMIN_LOGIN) : push(UiRoutes.LOGIN);
    }
  });

  // useEffect(() => {
  //   if (!isAdmin && isCiti && !citiMerchantIds.includes(props.loginState.MerchantId.toString())) {
  //     props.logOutAction();
  //     isAdmin ? push(UiRoutes.ADMIN_LOGIN) : push(UiRoutes.LOGIN);
  //     removeUserAuthenticated();
  //     }
  // }, [props.loginState.MerchantId]);

  useEffect(() => {
    props.getClientSecretKeyAction();
    if (!isPublicSelfServeRoute) {
      props.refreshTokenAction(getRefreshTokenPayloadForPath(location.pathname));
    }
    props.validationErrorAction();
  }, []);
  const prevPath = useRef();
  const dispatch = useDispatch();
  const mappedProducts = useSelector(
    (state: any) => state?.loginReducer?.loginState?.mappedProducts
  );

  useEffect(() => {
    const previousProduct = prevPath?.current
      ? (prevPath.current as string).split('/')[1]
      : '';
    const currentProduct = location?.pathname?.split('/')[1];
    if (previousProduct !== currentProduct) {
      const selectedProduct = getSelectedProductFromPath(
        currentProduct,
        mappedProducts
      );
      dispatch(
        updateSelectedProductOnPathChange({
          selectedProduct,
        })
      );
    }
    prevPath.current = location.pathname;
  }, [location]);

  useEffect(() => {
    const { isSuccess, data } = props.completeProfileState;
    if (kycdata?.UATMID && isSuccess && data) {
      const tempData = JSON.parse(JSON.stringify(kycdata));
      updateProfileStatus(data, tempData);
      setKycdata({});
    }
  }, [props.completeProfileState, kycdata]);

  const updateProfileStatus = (profiledata, kycdata) => {
    const dataToUpdate = {
      ...profiledata,
      profileStatus: {
        ...profiledata.profileStatus,
        status: statusMapper[kycdata.event],
        message:
          ProfileMessageMapping[statusMapper[kycdata.event]] ||
          profiledata.profileStatus.message,
      },
      merchantProfile: { ...profiledata.merchantProfile, kycProfile: kycdata },
    };
    props.updateMerchantProfileStore(dataToUpdate);
    props.updateMerchantProfileAction(dataToUpdate);
  };

  useEffect(() => {
    const {
      token,
      tokenExpiryInSec,
      isUserAuthenticated,
      isTokenFailure,
      // invalidPath,
      selectedProduct,
    } = props.loginState;

    if (isPublicSelfServeRoute) {
      return;
    }

    if (token?.length > 0 && isUserAuthenticated) {
      setUserAuthenticated();
      // if (invalidPath && selectedProduct === null) {
      //   push(generatePath(UiRoutes.HOME));
      // }

      const userEmail = props?.loginState?.UserEmail;
      const selectedMid = Number(selectedProduct?.mid);

      const identity = selectedMid === -1 ? `self-serve|${userEmail}` : selectedMid;

      pushClevertapProfile(identity);
      const merchantDisplayName = props?.loginState?.MerchantList?.filter(
        (merchant) => merchant?.productMerchantId === selectedProduct?.mid
      )?.merchantDisplayName;
      pushProfileProperties({
        'Email Id': props?.loginState.UserEmail,
        'Merchant ID': selectedProduct?.mid,
        'Merchant Name': merchantDisplayName,
        'Unified Mid': props?.loginState?.MerchantId,
      });

      // Push profile to Last9 RUM
      pushLast9Profile({
        'id': identity,
        'Email Id': props?.loginState.UserEmail,
        'Merchant ID': selectedProduct?.mid,
        'Merchant Name': merchantDisplayName,
        'Unified Mid': props?.loginState?.MerchantId,
      });

      const tokenExpiryInMilliSeconds = convertSecondsToMilliSeconds(
        tokenExpiryInSec - REFRESH_TOKEN_MARGINAL_TIME
      );

      const tokenExpiryTimer = setTimeout(() => {
        props.refreshTokenAction({ pathName: pathName?.split('/')[1] });
      }, tokenExpiryInMilliSeconds);

      return () => {
        clearTimeout(tokenExpiryTimer);
      };
    }
     if (isTokenFailure) {
      removeUserAuthenticated();
      props.clearLogOutAction();
      props.clearLoginAction();
      isAdmin ? push(UiRoutes.ADMIN_LOGIN) : push(UiRoutes.LOGIN);
    }
  }, [
    props.loginState.token,
    props.loginState.isUserAuthenticated,
    props.loginState.tokenExpiryInSec,
    props.loginState.selectedProduct,
    isPublicSelfServeRoute,
    // props?.loginState?.invalidPath,
  ]);

  useEffect(() => {
    const { isSuccess, isUserLoggedOut, isFailure } = props.logOutState;
    if (isFailure || (isSuccess && !isUserLoggedOut)) {
      props.clearLogOutAction();
      props.clearLoginAction();
      isAdmin ? push(UiRoutes.ADMIN_LOGIN) : push(UiRoutes.LOGIN);
    } else if (isSuccess && isUserLoggedOut) {
      props.clearLogOutAction();
      props.clearLoginAction();
      removeIsLiveMerchant();
      isAdmin ? push(UiRoutes.ADMIN_LOGIN) : push(UiRoutes.LOGIN);
      notify({
        message: 'Success',
        type: 'success',
        description: 'Logged out successfully.',
        duration: 0.75,
      });
    removeUserAuthenticated();
  }

  }, [props.logOutState]);

  useEffect(() => {
    if (
      props.loaderState &&
      Array.isArray(props.loaderState.actionsLoading) &&
      props.loaderState.actionsLoading.length &&
      !isLoading
    ) {
      setIsLoading(true);
    } else if (
      props.loaderState &&
      Array.isArray(props.loaderState.actionsLoading) &&
      props.loaderState.actionsLoading.length === 0
    ) {
      setIsLoading(false);
    }
  }, [props.loaderState]);

   useEffect(() => {
    // Must run before L9RUM.init so XHR response bodies are captured
    // before beforeSend fires. Returns an uninstall function used below.
    const uninstall = installNetworkErrorBodyCapture();
    L9RUM.init({
      baseUrl: process.env.REACT_APP_LAST9_RUM_URL || "",
      headers: {
        clientToken: process.env.REACT_APP_LAST9_RUM_CLIENT_TOKEN || "",
      },
      sampleRate: 100,
      resourceAttributes: {
        serviceName: "Unified Dashboard Frontend",
        deploymentEnvironment: process.env.REACT_APP_BUILD_ENV || "dev",
        appVersion: "1.0.0",
      },
      errors: {
        console: true, // Console errors (default: true)
        global: true, // Unhandled exceptions (default: true)
        report: true, // Browser reporting API (default: true)
        network: true, // Failed requests (default: true)
        ignorePatterns: [/ResizeObserver/i], // Regex patterns to ignore
        beforeSend: (event: any) => {
          // Filter or enrich errors before sending
          if (
            event.attributes["exception.message"]?.includes("ExpectedNoise")
          ) {
            return null; // Drop this error
          }

          // Attach actual upstream error details for network errors
          if (event.attributes["error.source"] === "network") {
            const url: string = event.attributes["http.url"] ?? "";
            const rawBody = getErrorResponseBody(url);
            event.attributes["error.upstreamMessage"] = rawBody
              ? extractUpstreamMessage(rawBody)
              : event.attributes["exception.message"] ?? "";
            event.attributes["error.upstreamStatusCode"] =
              event.attributes["http.status_code"] ?? "";
            event.attributes["error.upstreamUrl"] = url;
            if (rawBody) {
              event.attributes["error.upstreamResponseBody"] =
                rawBody.substring(0, 500);
            }
          }
          return event;
        },
      },
      network: {
        backendCorrelation: {
          enabled: true,
          corsAllowedOrigins: [
            `${process.env.REACT_APP_TOGGLE_LIVE_DOMAIN}`,
          ], // Domains to include
          // customHeaders: { "x-app-name": "web-client" }, // Additional headers
          injectToAllRequests: true, // Set true only if all APIs support it
        },
      },
      interactions: {
        enabled: true, // opt in explicitly
        trackClicks: true,
        trackScroll: true, // throttled; default 500ms
        trackKeyboard: false, // off by default for privacy
        trackForm: true, // focus/input on non-sensitive fields
        trackTouch: true,
        captureElementText: false, // trim to 100 chars when enabled
        selectorDepth: 3, // depth used for simple selectors
        throttleMs: 500,
      },
    });
    return () => {
      L9RUM.clearUser();
      uninstall(); // restore XHR prototype, stop pruning interval, clear cache
    };
  }, []);

  useEffect(() => {
    if (!props.loginState.isUserAuthenticated) return;
    if (isAdmin) {
      props.setUserDataAction({ isDisputesEnabled: true });
      return;
    }
    if (DISPUTES_FEATURE_API_ENABLED) {
      props.getDisputesFeatureFlagAction();
    } else {
      props.setUserDataAction({ isDisputesEnabled: true });
    }
  }, [props.loginState.isUserAuthenticated]);

  const checkPermissionMethod = useCallback(
    (permissions: Array<permissionEnum>): boolean => {
      return permissions.some((permissionName) =>
        checkPermissions(permissionName)
      );
    },
    [JSON.stringify(props.userPermissions)]
  );

  const renderLayout = (config: routeConfigType): JSX.Element => {
    switch (config.layout) {
      case 'admin':
        return (
          <AdminLoginPrivateRoute
            path={config.path}
            component={config.component}
            key={config.key}
            exact={config.exact}
          />
        );
      case 'partner-layout':
          return (
            <PartnerMerchantPrivateRoute
              path={config.path}
              component={config.component}
              key={config.key}
              exact={config.exact}
            />
          );
      case 'merchant':
        return (
          <PrivateRoute
            path={config.path}
            component={config.component}
            key={config.key}
            exact={config.exact}
          />
        );
      case 'public':
        return (
          <OpenRoute
            path={config.path}
            component={config.component}
            key={config.key}
          />
        );
      case 'merchant-payout':
        return (
          <PayoutPrivateRoute
            path={config.path}
            component={config.component}
            key={config.key}
            exact={config.exact}
          />
        );
      case 'merchant-payment-link':
        return (
          <PaymentLinksPrivateRoute
            path={config.path}
            component={config.component}
            key={config.key}
            exact={config.exact}
          />
        );
      case 'edge-merchant-payment-link':
        return (
          <EdgePaymentLinksPrivateRoute
            path={config.path}
            component={config.component}
            key={config.key}
            exact={config.exact}
          />
        );
      case 'profile':
        return (
          <ProfileRoute
            path={config.path}
            component={config.component}
            key={config.key}
            exact={config.exact}
          />
        );
      case 'common-layout':
        return (
          <CommonLayout
            path={config.path}
            component={config.component}
            key={config.key}
            exact={config.exact}
          />
        );
      case 'edge-private':
        return (
          <EdgePrivateRoute
            path={config.path}
            component={config.component}
            key={config.key}
            exact={config.exact}
          />
        );
      case 'complete-profile':
      return (
        <CompleteProfileRoute
          path={config.path}
          component={config.component}
          key={config.key}
          exact={config.exact}
        />
      );
      case 'merchant-subscription':
      return (
        <SubscriptionPrivateRoute
          path={config.path}
          component={config.component}
          key={config.key}
          exact={config.exact}
        />
      );
      case 'public-self-serve-profile':
        return (
          <PublicCompleteProfileRoute
            path={config.path}
            component={config.component}
            key={config.key}
            exact={config.exact}
          />
        );
      default:
        return (
          <PrivateRoute
            path={config.path}
            component={config.component}
            key={config.key}
            exact={config.exact}
          />
        );
    }
  };

  const renderRoute = (config: routeConfigType): JSX.Element | undefined => {
    const isAdapter = getIsAdapterFromStore();
    if(isAdapter && config.key === 'edgeTransaction'){
      config = {...config, component: EdgeV3Payments};
    }

    if (isAdapter && config.key === 'edgeRefunds') {
      config = { ...config, component: EdgeV3Payments };
    }


    if (
      config.path === UiRoutes.EDGE_DISPUTES ||
      config.path === UiRoutes.EDGE_DISPUTE_DETAILS
    ) {
      if (!props.loginState.isDisputesEnabled) {
        return undefined;
      }
    }

    if (config.allowedPermission) {
      if (checkPermissionMethod(config.allowedPermission)) {
        return renderLayout(config);
      }
      return undefined;
    } else if (config.path === UiRoutes.UNIFIED_MERCHANT_VERSION_UPDATE || config.path === UiRoutes.UNIFIED_MERCHANT_VERSION_LISTING) {
      return checkPermissions('MIGRATE_CHECKOUT_MERCHANTS') && getIsAdminFromStore()
        ? renderLayout(config)
        : undefined;
    } else {
      return renderLayout(config);
    }
  };

  return (
    <>
      {!isOnline ? (
        <ErrorScreen
          errorBackground={imgURL['error-background']}
          squareImg={imgURL['square-four']}
        ></ErrorScreen>
      ) : (
        <Suspense
          fallback={<Loader variant='section' className='loader-section--route' />}
        >
          <Switch>
            {routesConfig.map((config) => renderRoute(config))}
            <Route path='/'>
              {shouldDeferRootRedirect(location.pathname, props.loginState) ? (
                <React.Fragment />
              ) : (
                <Redirect to={getRootRedirectPath(props.loginState)} />
              )}
            </Route>
          </Switch>
        </Suspense>
      )}
      {isLoading && (
        <Loader
          blocking={false}
          message={props.loaderState?.loaderMessage}
        />
      )}

      {props.loginState.isUserAuthenticated &&
        props.loginState.IdleTimeOutTime > 0 &&
        props.loginState.HardLogOutTime > 0 && (
          <IdleTimerContainer
            idleTimeout={props.loginState.IdleTimeOutTime}
            afterIdleHardLogoutTime={props.loginState.HardLogOutTime}
            logoutAction={() => props.logOutAction()}
            refreshTokenAction={() =>
              props.refreshTokenAction({ pathName: pathName?.split('/')[1] })
            }
          />
        )}

      {/* Need below images in offline Mode */}
      <img
        src={imgURL['error-background']}
        style={{ width: '0px', height: '0px', display: 'none' }}
      />
      <img
        src={imgURL['square-four']}
        style={{ width: '0px', height: '0px', display: 'none' }}
      />
    </>
  );
};

const mapStateToProps = ({
  loaderReducer,
  loginReducer,
  completeProfileReducer,
  onboardingReducer,
  MerchantListingReducer,
  sidebarReducer,
}) => ({
  loaderState: loaderReducer,
  loginState: loginReducer.loginState,
  logOutState: loginReducer.logOutState,
  userPermissions: loginReducer.permissionState,
  completeProfileState: completeProfileReducer?.completeProfileState,
  stepperDetails: onboardingReducer.stepperDetails,
  themingDetails: getDashboardThemeDetails(MerchantListingReducer.merchantOdsData),
  isCollapsed: sidebarReducer.isCollapsed,
});

export default connect(mapStateToProps, {
  getMerchantOdsDataAction,
  refreshTokenAction,
  clearLoginAction,
  logOutAction,
  clearLogOutAction,
  validationErrorAction,
  clearValidationErrorAction,
  getClientSecretKeyAction,
  updateMerchantProfileAction,
  updateMerchantProfileStore,
  getDisputesFeatureFlagAction,
  setUserDataAction,
})(App);
